import styled from "@emotion/styled/macro";
import {
  AdminIcon,
  AdminIcon2,
  DataPieIcon,
  GrayArrowRight,
  TracktorAndGlassIcon,
  TracktorIcon,
  RealAdminIcon,
  NokIcon,
  NoticeIcon,
  DetectListIcon,
  AccidentMarker,
  WarningEscapeMarker,
  WarningBatteryMarker,
  DangerousAreaMarker,
  DangerousDrivingMarker,
  IdleTimeMarker,
  LockOpenMarker,
  DetectPastIcon,
} from "../../assets/icons/icons";
import ReusableCard from "../../components/reusableCard";
import theme from "../../theme";
import { SelectChangeEvent } from "@mui/material/Select";
import { useEffect, useState } from "react";
import SelectBox from "../../components/selectBox";
import { useNavigate } from "react-router-dom";
import Header from "./header";
import useGetDetectToday from "../../hooks/useGetDetectToday";
import userStorage from "../../utils/userStorage";
import Spinner from "../../components/spinner";
import useGetNotice from "../../hooks/useGetNotice";
import NewNoticeCarousel from "../../components/newNoticeCarousel";
import Footer from "../../components/footer";
import { getEventOptions } from "../../utils/constants";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import { formatDate, textSubstring } from "../../utils/util";
//import { DailyWarning } from "../../components/DailyWarning";
import { useI18n } from "../../locales";

export interface ItemType {
  header_seq: number;
  seq: number;
  name: string;
  mobility_type: string;
  code_name: string;
  registered_at: string;
  status: string;
  latitude: number;
  longitude: number;
}

const { sm, md, lg } = theme.screen;

const Home: React.FC<{}> = () => {
  const { t } = useI18n();
  const user = userStorage.get();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState(0);
  const [toggle, setToggle] = useState(false);
  const [responsibleWidth, setResponsibleWidth] = useState(30);
  const [openNewNoticeCarousel, setOpenNewNoticeCarousel] = useState(true);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
  });

  const { data, isLoading } = useGetDetectToday({
    event_code: filter,
    area: user?.area as string,
  });

  const { data: newNoticeData, isLoading: newNoticeDataIsLoading } =
    // useGetNotice(page, newCheck, limit); newCheck 0 : 1일이내 , null: 전체
    useGetNotice(0, 0, -1);

  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth,
    });
  };

  useEffect(() => {
    if (Number(windowSize.width) < 451) {
      setResponsibleWidth(30);
      return;
    }
    if (Number(windowSize.width) <= theme.screen.md) {
      setResponsibleWidth(50);
      return;
    }
    if (Number(windowSize.width) <= theme.screen.lg) {
      setResponsibleWidth(100);
      return;
    }
  }, [windowSize]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const navigateTo = (screen: string) => {
    navigate(`${screen}`);
  };

  const handleChange = (event: SelectChangeEvent) => {
    setFilter(Number(event.target.value));
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const matchImage = (el: string) => {
    if (el === "차량전복") {
      return <AccidentMarker />;
    } else if (el === "사용지역이탈") {
      return <WarningEscapeMarker />;
    } else if (el === "도난감지") {
      return <LockOpenMarker />;
    } else if (el.indexOf("배터리부족") >= 0) {
      return <WarningBatteryMarker />;
    } else if (el === "위험운전") {
      return <DangerousDrivingMarker />;
    } else if (el === "시동방치") {
      return <IdleTimeMarker />;
    } else {
      return <DangerousAreaMarker />;
    }
  };

  const onClickItem = (el: ItemType) => {
    if (el.status === "실시간") {
      navigate(`/control`, {
        state: {
          from: "home",
          data: el,
        },
      });
    } else {
      navigate(`/control/past`, {
        state: {
          from: "home",
          data: el,
        },
      });
    }
  };

  // console.log(data);

  return (
    <Wrapper>
      {/* 금일 점검 요망 농기계 목록 플로팅 버튼 */}
      {/* <DailyWarning /> */}
      {newNoticeData && newNoticeData.list.length > 0 && (
        <NewNoticeCarousel
          openNewNoticeCarousel={openNewNoticeCarousel}
          setOpenNewNoticeCarousel={setOpenNewNoticeCarousel}
          newNoticeData={newNoticeData}
          isLoading={newNoticeDataIsLoading}
        />
      )}
      <Header />
      <Body>
        <Box1>
          <ReusableCard
            onClick={() => navigateTo(`/control`)}
            title="사고 관제"
            icon={<TracktorIcon />}
          />

          {/* <ReusableCard
            onClick={() => navigateTo(`/control/past`)}
            title="과거 감지내역 조회"
            icon={<DetectPastIcon />}
            fillCircle={true}
          /> */}

          <ReusableCard
            onClick={() => navigateTo(`/detect-list`)}
            title="감지내역 조회"
            icon={<DetectListIcon />}
          />
          <ReusableCard
            onClick={() => navigateTo("/mobile-list")}
            title="농기계 관리"
            icon={<TracktorAndGlassIcon />}
          />
          <ReusableCard
            onClick={() => navigateTo("/stastics")}
            // title="감지내역 통계"
            title="통계"
            icon={<DataPieIcon />}
          />
          <ReusableCard
            onClick={() => navigateTo("/notice")}
            title="공지사항"
            icon={<NoticeIcon />}
            newNotice={newNoticeData && newNoticeData.list.length > 0}
          />

          {user?.grade === 2 && user?.area === "00000" && (
            <ReusableCard
              onClick={() => navigateTo("/admin")}
              title="사용자 계정 관리"
              icon={<RealAdminIcon />}
              fillCircle={true}
            />
          )}
          <ReusableCard
            onMouseEnter={() => setToggle(true)}
            onMouseLeave={() => setToggle(false)}
            onClick={() => navigateTo("/customer")}
            title="소유자 관리"
            icon={toggle ? <AdminIcon2 /> : <AdminIcon />}
          />
          <ReusableCard
            onClick={() => navigateTo("/nok")}
            title="추가 알림 수신자 관리"
            icon={<NokIcon />}
            fillCircle={true}
          />
        </Box1>
        <Box2>
          <Box2Header>
            <strong>금일 감지 내역 - {data?.total_count ?? 0}건</strong>
            <SelectBox
              title="감지 종류 선택"
              open={open}
              handleChange={handleChange}
              handleClose={handleClose}
              handleOpen={handleOpen}
              filter={filter}
              menuItems={getEventOptions(t)}
              srLabel="감지 종류 선택"
            />
          </Box2Header>
          <Box2Body>
            {isLoading && <Spinner />}
            {data &&
              data.total_count !== 0 &&
              data?.result?.map((el) => (
                <DetectItem
                  key={el.header_seq + el.code_name}
                  onClick={() => onClickItem(el)}
                  hoverColor={
                    el.code_name?.includes("차량전복")
                      ? theme.color.red_100
                      : el.code_name === null
                      ? theme.color.neutral_100
                      : theme.color.orange_100
                  }
                >
                  <ImageWrapper>{matchImage(el.code_name)}</ImageWrapper>
                  <InfoWrapper>
                    <CodeName>{el.code_name}</CodeName>

                    {/* 기기종류 */}
                    <CustomTooltip
                      title={el?.mobility_type}
                      active={el?.mobility_type?.length > 12}
                    >
                      <MobilityInfo>
                        기기 종류: {textSubstring(el.mobility_type, 0, 12)}
                      </MobilityInfo>
                    </CustomTooltip>

                    {/* 소유자 */}
                    <CustomTooltip
                      title={el?.name}
                      active={el?.name?.length > 13}
                    >
                      <MobilityInfo>
                        소유자: {textSubstring(el.name, 0, 13)}
                      </MobilityInfo>
                    </CustomTooltip>

                    <OtherInfo>
                      {formatDate(el.registered_at, "HH시mm분")}
                      <span
                        style={{
                          color:
                            el.status === "실시간"
                              ? theme.color.red_500
                              : theme.color.green_500,
                        }}
                      >
                        [{el.status}]
                      </span>
                    </OtherInfo>
                  </InfoWrapper>
                  <GrayArrowRight />
                </DetectItem>
              ))}
            {!isLoading && (!data || data?.result.length === 0) && (
              <NoDetect>조회내역이 없습니다.</NoDetect>
            )}
          </Box2Body>
        </Box2>

        {/* 모바일용 아이콘 */}
        <Box3>
          <ReusableCard
            onClick={() => navigateTo("/control")}
            title="사고 관제"
            icon={
              <TracktorIcon
                width={responsibleWidth}
                height={responsibleWidth}
              />
            }
          />
          <ReusableCard
            onClick={() => navigateTo("/control/past")}
            title="과거 감지내역"
            icon={
              <DetectPastIcon
                width={responsibleWidth}
                height={responsibleWidth}
              />
            }
            fillCircle={true}
          />

          <ReusableCard
            onClick={() => navigateTo("/detect-list")}
            title="감지내역 조회"
            icon={
              <DetectListIcon
                width={responsibleWidth}
                height={responsibleWidth}
              />
            }
          />
          <ReusableCard
            onClick={() => navigateTo("/mobile-list")}
            title="농기계 관리"
            icon={
              <TracktorAndGlassIcon
                width={responsibleWidth}
                height={responsibleWidth}
              />
            }
            fillCircle={false}
          />
          <ReusableCard
            onClick={() => navigateTo("/stastics")}
            // title="감지내역 통계"
            title="통계"
            icon={
              <DataPieIcon
                width={responsibleWidth}
                height={responsibleWidth}
              />
            }
          />
          <ReusableCard
            onClick={() => navigateTo("/notice")}
            title="공지사항"
            icon={
              <NoticeIcon
                width={responsibleWidth}
                height={responsibleWidth}
              />
            }
            newNotice={newNoticeData && newNoticeData.list.length > 0}
          />

          {user?.grade === 2 && user?.grade === 2 && (
            <ReusableCard
              onClick={() => navigateTo("/admin")}
              title="사용자 계정 관리"
              icon={
                <RealAdminIcon
                  width={responsibleWidth}
                  height={responsibleWidth}
                />
              }
              fillCircle={true}
            />
          )}
          <ReusableCard
            onMouseEnter={() => setToggle(true)}
            onMouseLeave={() => setToggle(false)}
            onClick={() => navigateTo("/customer")}
            title="소유자 관리"
            icon={
              toggle ? (
                <AdminIcon2
                  width={responsibleWidth}
                  height={responsibleWidth}
                />
              ) : (
                <AdminIcon
                  width={responsibleWidth}
                  height={responsibleWidth}
                />
              )
            }
          />
          <ReusableCard
            onClick={() => navigateTo("/nok")}
            // title="추가 알림 수신자 관리"
            title="추가 수신자 관리"
            icon={
              <NokIcon
                width={responsibleWidth}
                height={responsibleWidth}
              />
            }
            fillCircle={true}
          />
        </Box3>
      </Body>
      <Footer />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background-color: ${theme.color.white};
  margin: 0 auto;

  @media (max-width: ${sm}px) {
    display: flex;
    flex-direction: column;
    min-width: 320px;
    width: 100vw;
    overflow-y: auto;
    ::-webkit-scrollbar {
      display: none;
    }
  }
  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    height: 100vh;
    min-width: 680px;
    width: 100vw;
  }
  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    height: 100vh;
  }
  @media (min-width: ${lg + 1}px) {
    height: 100vh;
    max-width: 1440px;
    min-width: 1440px;
  }
`;

const Body = styled.div`
  padding: 14px 30px 30px 30px;
  display: flex;
  gap: 30px;
  background: ${theme.color.white};
  @media (max-width: ${sm}px) {
    flex-grow: 1;
    gap: 30px;
    flex-direction: column;
    align-items: center;
    padding: 15px;
    padding-top: 30px;
    overflow-y: auto;
    ::-webkit-scrollbar {
      display: none;
    }
  }
`;

const Box1 = styled.div`
  display: none;

  @media (min-width: ${lg + 1}px) {
    width: 70%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 30px;
    grid-row-gap: 30px;
  }
`;

const Box2 = styled.div`
  background: ${theme.color.neutral_50};
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  display: flex;
  flex-direction: column;

  @media (max-width: ${sm}px) {
    flex-grow: 1;
    min-height: 300px;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    min-width: 300px;
    order: -1;
    width: 405px;
    flex-shrink: 0;
    overflow-y: auto;
  }
  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    order: -1;
    overflow-y: auto;
    width: 405px;
    flex-shrink: 0;
  }
  @media (min-width: ${lg + 1}px) {
    order: -1;
    width: 30%;
    overflow-y: auto;
  }
`;

const Box3 = styled.div`
  display: none;

  @media (max-width: ${sm}px) {
    order: -1;
    display: grid;
    place-items: center;
    width: 100%;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 20px;
    grid-row-gap: 20px;
  }
  @media (min-width: ${sm + 1}px) and (max-width: ${md}px) {
    min-width: 200px;
    display: block;
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex-grow: 1;
  }
  @media (min-width: ${md + 1}px) and (max-width: ${lg}px) {
    flex-grow: 1;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 10px;
  }
`;

const Box2Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  padding-top: 25px;
  padding-bottom: 20px;
  align-items: center;
  border-bottom: 3px solid ${theme.color.neutral_200};

  @media (max-width: ${sm}px) {
    padding: 5px;
    padding-left: 20px;
  }
  strong {
    font-weight: 700;
    font-size: 18px;
    line-height: 21px;
    color: ${theme.color.neutral_600};
    @media (max-width: 330px) {
      font-size: 14px;
    }

    @media (min-width: 330px) and (max-width: ${md}px) {
      font-size: 15px;
    }
  }
`;
export const DetectItem = styled.div<{
  hoverColor?: string;
  accentColor?: string;
  active?: boolean;
}>`
  padding: 22px 20px;
  background-color: ${theme.color.white};
  min-height: 105px;
  width: 100%;
  border-bottom: 1px solid ${theme.color.neutral_200};
  display: flex;
  gap: 20px;
  align-items: center;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  &:hover {
    background-color: ${({ hoverColor }) => hoverColor};
  }
  background-color: ${({ active, hoverColor }) =>
    active ? hoverColor : theme.color.white};

  border-left: ${({ active, accentColor }) =>
    active ? `5px solid ${accentColor}` : "none"};

  @media (max-width: ${sm}px) {
    gap: 15px;
    padding: 22px 15px;
  }
`;

const Box2Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (min-width: ${md + 1}px) {
    max-height: 730px;
  }
  ${DetectItem}:last-child {
    border-bottom: none;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
`;

export const CodeName = styled.strong<{ isRed?: boolean }>`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: ${theme.color.neutral_600};
  color: ${({ isRed }) =>
    isRed ? theme.color.red_500 : theme.color.neutral_600};
  display: flex;
  gap: 7px;
  overflow: hidden;
  align-items: center;
`;

export const MobilityInfo = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: ${theme.color.neutral_600};
  @media (max-width: ${md}px) {
    /* display: none; */
  }
`;

export const MobilityInfoForMobile = styled.span`
  display: none;
  @media (max-width: ${md}px) {
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${theme.color.neutral_600};
  }
`;

export const OtherInfo = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: ${theme.color.neutral_500};
  span {
    margin-left: 5px;
  }

  @media (max-width: ${sm}px) {
    font-size: 11px;
    span {
      font-size: 11px;
    }
  }
`;

const NoDetect = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default Home;
